import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { Box, Button, Stack, Typography } from '@mui/material';

function NotFoundScreen({ onNavigate }) {
  return (
    <Box className="screen">
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Typography variant="overline" color="text.secondary">
          404
        </Typography>
        <Typography variant="h2">Screen not found</Typography>
        <Button variant="contained" size="large" startIcon={<HomeRoundedIcon />} onClick={() => onNavigate('/')}>
          Go Home
        </Button>
      </Stack>
    </Box>
  );
}

export default NotFoundScreen;
